export enum HorizontalListActions {
  ShowDisclosures = "showDisclosures"
}
